import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedIntegration: null,
  openFinalPopup: false,
};

export const integrationSlices = createSlice({
  name: 'integrationSlices',
  initialState,
  reducers: {
    setSelectedIntegration(state, action) {
      state.openFinalPopup = false;
      state.selectedIntegration = action.payload;
    },
    setOpenFinalPopup(state, action) {
      state.openFinalPopup = action.payload;
    },
  },
});

export const { setSelectedIntegration, setOpenFinalPopup } = integrationSlices.actions;

export default integrationSlices.reducer;
